import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";

type Props = {
  foto?: string | null;
  namasiswa?: string | null;
  kelas?: string | null;
  marhalah?: string | null;
  gender?: string;
  isPending?: boolean;
};

export const ProfileAvatarHeader = ({
  foto,
  namasiswa,
  kelas,
  marhalah,
  gender = "",
  isPending = false,
}: Props) => {
  const avatarSrc =
    isPending || !foto
      ? gender === "Wanita" || gender === "WANITA"
        ? FemaleLogo
        : MaleLogo
      : `https://tarshib.sipond.id/assets/fotosiswa/${foto}`;

  return (
    <>
      <div className="tw-absolute tw-top-0 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2">
        <img
          src={avatarSrc}
          alt=""
          className="tw-w-24 tw-h-24 tw-object-cover tw-rounded-full tw-border-4 tw-border-solid tw-border-white tw-shadow-md tw-bg-gray-100"
        />
      </div>

      <div className="tw-text-base tw-font-semibold tw-text-text-primary tw-mb-0.5">
        {namasiswa ?? "---"}
      </div>

      <div className="tw-text-xs tw-text-text-secondary">
        Kelas {kelas} · Marhalah {marhalah}
      </div>
    </>
  );
};
